export default "__VITE_ASSET__DLGqV_Ac__"